const thumbSwiper = new Swiper('.thumbs-container', {
  spaceBetween: 15,
  slidesPerView: 6,
  breakpoints: { 
    768: {
      touchRatio: 0,
      spaceBetween: 8,
    }
  },
  navigation: {
    nextEl: '.gallery.swiper-button-next',
    prevEl: '.gallery.swiper-button-prev',
  },
});
   
const mainSwiper = new Swiper('.main-container', {
  slidesPerView: 1,
  autoHeight: true,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
  thumbs: {
    swiper: thumbSwiper
  },
  navigation: {
    nextEl: '.mainimg.swiper-button-next',
    prevEl: '.mainimg.swiper-button-prev',
  },
});

refreshFsLightbox();

// MARK:- Metal selection updates only the gallery, never the product form.
class MetalVariantGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.metal = gallery.dataset.initialMetal;
    this.main = gallery.querySelector('.main-container')?.swiper;
    this.thumbs = gallery.querySelector('.thumbs-container')?.swiper;
    this.slides = this.main ? Array.from(this.main.wrapperEl.children).filter(
      (slide) => !slide.classList.contains('swiper-slide-duplicate')
    ) : [];
    this.thumbSlides = this.thumbs ? Array.from(this.thumbs.wrapperEl.children) : [];
    this.desktopSlots = Array.from(gallery.querySelectorAll('.pdp-gallery-img .gallery-image-link'));
    this.desktopMedia = this.desktopSlots.map((slot) => Array.from(slot.childNodes));
  }

  imageKey(element) {
    const image = element.querySelector('img');
    return image ? new URL(image.getAttribute('src'), window.location.href).pathname : null;
  }

  update(variant) {
    const metal = variant?.options[Number(this.gallery.dataset.metalOptionIndex)];
    if (!metal || metal === this.metal) return;
    this.metal = metal;
    const isGold = /gold/i.test(metal) && !/rose/i.test(metal);
    if (!isGold && !/silver|rose.*gold/i.test(metal)) return;
    // A missing assigned image must leave both galleries and their position untouched.
    if (!variant.featured_media) return;
    const template = this.gallery.querySelector(`[data-metal-media-id="${variant.featured_media.id}"]`);
    if (!template) return;
    const key = this.imageKey(template.content);
    const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : (this.main?.params.speed ?? 300);

    if (this.main && this.slides.length) {
      this.main.loopDestroy();
      let orderedSlides = this.slides;
      if (!isGold && this.imageKey(this.slides[0]) !== key) {
        let selectedSlide = this.slides.find((slide) => this.imageKey(slide) === key);
        if (!selectedSlide) {
          selectedSlide = document.createElement('div');
          selectedSlide.className = 'swiper-slide';
          selectedSlide.appendChild(template.content.cloneNode(true));
        }
        orderedSlides = [selectedSlide, ...this.slides.filter((slide) => slide !== selectedSlide)];
      }
      this.main.wrapperEl.replaceChildren(...orderedSlides);

      if (this.thumbs) {
        const orderedThumbs = orderedSlides.map((slide) => {
          const slideKey = this.imageKey(slide);
          const mediaId = slide.querySelector('[data-media-id]')?.dataset.mediaId;
          const existing = this.thumbSlides.find((thumb) =>
            (slideKey && this.imageKey(thumb) === slideKey) ||
            (mediaId && thumb.querySelector('[data-thumbnail-id]')?.dataset.thumbnailId === mediaId)
          );
          if (existing) return existing;
          if (!slideKey) return null;
          const thumb = document.createElement('div');
          thumb.className = 'swiper-slide';
          const image = slide.querySelector('img').cloneNode(true);
          const url = new URL(image.src);
          url.searchParams.set('width', '80');
          url.searchParams.set('height', '80');
          url.searchParams.set('crop', 'center');
          image.src = url.href;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.width = 80;
          image.height = 80;
          image.loading = 'lazy';
          thumb.appendChild(image);
          return thumb;
        }).filter(Boolean);
        this.thumbs.wrapperEl.replaceChildren(...orderedThumbs);
        this.thumbs.update();
        this.thumbs.slideTo(0, duration);
      }
      this.main.loopCreate();
      this.main.update();
      this.main.slideToLoop(0, duration);
      this.main.thumbs?.update();
      window.refreshFsLightbox?.();
    }

    if (this.desktopSlots.length) {
      this.extraDesktopRow?.remove();
      let orderedMedia = this.desktopMedia;
      if (!isGold) {
        const selectedIndex = this.desktopMedia.findIndex((nodes) => nodes.some((node) =>
          node.nodeType === 1 && node.matches('img') &&
          new URL(node.getAttribute('src'), window.location.href).pathname === key
        ));
        const selected = selectedIndex >= 0 ? this.desktopMedia[selectedIndex] :
          [template.content.querySelector('img').cloneNode(true)];
        orderedMedia = [selected, ...this.desktopMedia.filter((nodes) => nodes !== selected)];
      }
      this.desktopSlots.forEach((slot, index) => slot.replaceChildren(...orderedMedia[index]));
      if (orderedMedia.length > this.desktopSlots.length) {
        this.extraDesktopRow = document.createElement('div');
        this.extraDesktopRow.className = 'pdp-gallery-row pdp-gallery-row-1';
        this.extraDesktopRow.innerHTML = '<div class="pdp-gallery-img big"><div class="gallery-image-link"></div></div>';
        this.extraDesktopRow.querySelector('.gallery-image-link').append(...orderedMedia[orderedMedia.length - 1]);
        this.gallery.querySelector('.pdp-gallery-grid').appendChild(this.extraDesktopRow);
      }
    }
  }
}

window.updateMetalVariantGallery = (sectionId, variant) => {
  const gallery = document.querySelector(`[data-product-media-section="${sectionId}"][data-metal-option-index]`);
  if (!gallery) return false;
  gallery.metalVariantGallery ||= new MetalVariantGallery(gallery);
  gallery.metalVariantGallery.update(variant);
  return true;
};